function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makePopperStyles = function makePopperStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiPopper: {
      styleOverrides: {
        root: {
          "&.DhigFlyout": {
            background: "transparent",
            "&[class*='MuiTooltip-popper'][data-popper-placement*='top'] [class*='MuiTooltip-arrow']:before": {
              boxShadow: "0px 1px 0px 0px rgba(0, 0, 0, 0.6),0px 1px 0px 0px rgba(0, 0, 0, 0.6) inset,1px 0px 0px 0px rgba(0, 0, 0, 0.6) inset,-1px 0px 0px 0px rgba(0, 0, 0, 0.6) inset"
            },
            "&[class*='MuiTooltip-popper'][data-popper-placement*='top'] [class*='MuiTooltip-arrow']": {
              marginBottom: "".concat(primitives.spacings["0"]),
              bottom: "-14px"
            },
            "&[class*='MuiTooltip-popper'][data-popper-placement*='bottom'] [class*='MuiTooltip-arrow']": {
              top: "-13px",
              marginTop: primitives.spacings["0"]
            },
            "& [class*='MuiTooltip-tooltip']": {
              background: tokens.colors["fill-elevation-0"],
              boxShadow: tokens.effects["elevation-0-popover"],
              padding: "".concat(primitives.spacings["3"], " 1px ").concat(primitives.spacings["4"], " 1px"),
              borderRadius: primitives.borderRadii["medium"],
              "& [class*='MuiTooltip-arrow']": {
                fontSize: primitives.spacings["5"]
              },
              "& [class*='MuiTooltip-arrow']:before": {
                backgroundColor: primitives.colors.primary.white,
                boxShadow: tokens.effects["elevation-0-popover"]
              },
              "& [class*='MuiPaper-root']": {
                boxShadow: "none",
                '& [class*="MuiList-root"][role="menu"]': {
                  outline: "none"
                }
              },
              "& [class*='MuiMenuItem-root']": {
                padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["5"]),
                "&:focus": {
                  padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["5"]),
                  "&.Mui-selected": {
                    backgroundColor: tokens.colors["activated-fill-subtle"]
                  }
                },
                "& [class*='MuiSvgIcon-root']": {
                  position: "absolute",
                  right: primitives.spacings["3"]
                }
              },
              "& [class*='MuiMenuItem-root']:active": {
                background: tokens.colors["activated-pressed-fill-subtle"]
              }
            }
          },
          '&[class*="MuiAutocomplete-popper"]': {
            '& [class*="MuiPaper-root"]': _objectSpread(_objectSpread({}, tokens.typography["body-copy-medium"]), {}, {
              color: tokens.colors["ink-on-background"],
              boxShadow: tokens.effects["elevation-0-dropdown"],
              borderRadius: "".concat(primitives.borderRadii.none, " ").concat(primitives.borderRadii.none, " ").concat(primitives.borderRadii.medium, " ").concat(primitives.borderRadii.medium),
              margin: "".concat(primitives.spacings["1"], " ").concat(primitives.spacings["0"]),
              backgroundColor: tokens.colors["fill-elevation-0"],
              '& [class*="MuiAutocomplete-noOptions"]': {
                color: tokens.colors["ink-on-background"]
              },
              '& [class*="MuiAutocomplete-listbox"]': {
                '& [class*="MuiAutocomplete-option"]': _objectSpread(_objectSpread({
                  cursor: "pointer",
                  display: "flex",
                  boxSizing: "border-box",
                  alignItems: "center",
                  padding: "10px ".concat(primitives.spacings["3"]),
                  justifyContent: "flex-start"
                }, tokens.transitions["state-blur"]), {}, {
                  '&[aria-selected="true"]': {
                    backgroundColor: tokens.colors["activated-fill-subtle"]
                  },
                  '&[aria-disabled="true"]': {
                    opacity: "0.3",
                    pointerEvents: "none"
                  },
                  "&.Mui-focused:hover": _objectSpread({
                    backgroundColor: tokens.colors["hover-fill-subtle"]
                  }, tokens.transitions["state-activate"]),
                  "&.Mui-focused:active, &:active": _objectSpread({
                    backgroundColor: tokens.colors["pressed-fill-subtle"]
                  }, tokens.transitions["state-activate"]),
                  "&.Mui-focused.Mui-focusVisible": _objectSpread({
                    boxShadow: "inset ".concat(tokens.effects["focus-ring-thin"])
                  }, tokens.transitions["state-activate"]),
                  '& [class*="DhigCombobox--checkedIcon"]': {
                    position: "absolute",
                    right: primitives.spacings["3"]
                  },
                  '& [class*="MuiCheckbox-root"]': {
                    marginRight: primitives.spacings["2"]
                  },
                  '&[class*="DhigCombobox--selectAllOption"]': {
                    borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["divider-0"])
                  }
                }),
                "& li": {
                  '[class*="MuiListSubheader-root"]': {
                    borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["row-divider"]),
                    marginLeft: "1px",
                    marginRight: "1px",
                    background: tokens.gradients["fill-category-title"]
                  },
                  '&:first-of-type [class*="MuiListSubheader-root"]': {
                    borderTop: "none"
                  }
                }
              },
              '& [class*="MuiListSubheader-root"]': {
                backgroundColor: primitives.colors.detail.transparent
              },
              '& [class*="DhigCombobox--addendum"]': _objectSpread(_objectSpread({
                color: tokens.colors["detail-2-transparent"]
              }, tokens.typography["body-copy-small"]), {}, {
                padding: primitives.spacings["3"]
              })
            })
          }
        }
      }
    }
  };
};